<div class="container-fluid spacer-top-navigation">
  <div class="container mb-3">
    <div class="row row--primary">
      <div class="col-12 pl-0 mb-2 d-flex align-items-center">
        <a (click)="location.back()" class="link-secondary font-default cursor-pointer">
          <svg class="icon icon-21"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
          {{ 'savings-plan.add-savings-plan.back' | transloco }}
        </a>
      </div>
    </div>
    <div class="row row--primary d-block tile">
      <div class="col-12 pl-0 pr-0">
        <div class="row mb-5">
          <div class="col-12">
            <h1 class="zero-text p-bigger-bold">
              @if (savingsPlanFacade.isMultiSavingsPlanOrder$ | async) {
                {{ 'savings-plan.add-savings-plan.headline-multi' | transloco }}
              } @else {
                {{ 'savings-plan.add-savings-plan.headline' | transloco }}
              }
            </h1>
          </div>
          @if (hasCryptoAsset) {
            <div class="col-12">
              <shared-micar-contracts-nudging class="d-block mt-3" />
            </div>
          }
        </div>

        <saving-plans-options />
        <saving-plans-create-list [assets]="assets" />
        <saving-plans-crypto-hint (noWalletWarningClick)="noWalletWarningClick.emit()" />
        @if (hasCryptoAsset) {
          <trade-check-experience-and-ftg
            [assetToCheck]="lastCryptoAsset"
            (allowedToProceedOrderChange)="acceptRisk($event)"
            [showCancelButton]="false"
          />
        }
        <saving-plans-sum />
        <div class="row">
          <div class="col">
            <web-design-system-button
              data-zid="savingsplan-submit"
              [fullwidth]="true"
              [disabled]="
                (savingsPlanFacade.hasErrors$ | async) ||
                ((savingsPlanFacade.hasCryptoSavingsPlanSelected$ | async) &&
                  !(customerStateFacade.customerBaseData$ | async)?.hasActiveWallet) ||
                (hasCryptoAsset && !acceptCryptoRisk) ||
                (hasCryptoAsset && (contractConfirmationFacade.shouldDisplayNudgingNotification$ | async))
              "
              (click)="goNext.emit()"
            >
              @if (savingsPlanFacade.isMultiSavingsPlanOrder$ | async) {
                {{ 'savings-plan.savings-plan-form.submit-multi' | transloco | uppercase }}
              } @else {
                {{ 'savings-plan.savings-plan-form.submit' | transloco | uppercase }}
              }
            </web-design-system-button>
            <saving-plans-donau-capital-hint [hasCryptoAsset]="hasCryptoAsset" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
